module.exports = __webpack_public_path__ + "img/3936347.jpg";